export enum Platform {
  UNKNOWN = 'unknown',
  TIZEN = 'tizen',
  LG = 'lg',
  VIZIO = 'vizio',
  COMCAST = 'comcast',
}
